jQuery(function($){
  
  if (typeof Shopify === 'undefined') var Shopify = {};
  Shopify.HandlesInCart = [];
  	
  var cookieList = function(cookieName) {
      var cookie = $.cookie(cookieName);
      var items = cookie ? cookie.split(/,/) : new Array();
      return {
        "add": function(val) {
          items.push(val);
          $.cookie(cookieName, items.join(','),{expires:999999, path:'/'});
        },
        "remove": function (val) { 
          indx = items.indexOf(val); 
          if(indx!=-1) items.splice(indx, 1);           
          $.cookie(cookieName, items.join(','),{expires:999999, path:'/'});        
        },
        "clear": function() {
          items = null;
          $.cookie(cookieName, null);
        },
        "items": function() {
          return items;
        }
      }
    } 
  	
    var list = new cookieList('home_try_cart');
    $('body').on('click','.addToHomeTryBtnImg,.productaddHomeTry',function(e){
      e.preventDefault();
      console.log("xxxxxxxx");
      
      if(list.items().length < 4){
        var handleProduct = $(this).closest('.addToHomeTryBtn').attr('data-productHandle');
        var varientID = $(this).closest('.addToHomeTryBtn').attr('data-varientid');
        var stockID = $(this).closest('.addToHomeTryBtn').attr('data-stockvar');
        if(stockID > 0 ){
          list.add(handleProduct+'_variantID_'+varientID); 
          $(this).hide();
          $(this).next('.productaddedHomeTry ').show();
          $(this).closest('.product').find('.ci .addedTextMsg').addClass('open');
          $(this).next('.addedHomeTryBtn').addClass('disabled');
          $(this).next('.productaddedHomeTry ').addClass('disabled');

          $(this).closest('.product').find('.tooltiptext').addClass('hide');
          $('.homeTryImgAddedCart').show();
          $('.homeTryImgCart').hide();
          setTimeout(function(){
            $('.addedTextMsg').removeClass('open');
            $('.addedHomeTryBtn').removeClass('disabled');
          },1000);
          $(this).next('.addedHomeTryBtn').show();
          $('.homeCartItemCount').html(list.items().length);
          if(list.items().length == 4){
            window.location.href = 'https://madaboutspecs.co.uk/pages/home-try-cart'; 
          }
        }else{
        	alert('This option is Sold out');
        }
      }else{
      	alert('Your home try cart is full');
      }
    });
    $('body').on('click','.addedHomeTryBtn,.productaddedHomeTry',function(e){
      e.preventDefault();
      var handleProduct = $(this).closest('.addToHomeTryBtn').attr('data-productHandle');
      var varientID = $(this).closest('.addToHomeTryBtn').attr('data-varientid');
      var stockID = $(this).closest('.addToHomeTryBtn').attr('data-stockvar');
      var removeCookVlaue = list.remove(handleProduct+'_variantID_'+varientID); 
      var newCookiesValue = list.items();
      var blkstr = [];
      $.each(newCookiesValue, function(idx2,val2) {                    
        var str = val2;
        blkstr.push(str);
      });
      var NewValueofString = blkstr.join(",");
      console.log('NewValueofString-->',NewValueofString);
      $.cookie('home_try_cart', NewValueofString,{expires:999999, path:'/'});
      //list.add(NewValueofString); 
      $(this).hide();
      $(this).prev('.productaddHomeTry').show();
      $(this).prev('.addToHomeTryBtnImg').addClass('disabled');
      $(this).prev('.productaddHomeTry').addClass('disabled');
      $(this).closest('.product').find('.ci .removeTextMsg').addClass('open');
      $(this).closest('.product').find('.tooltiptext').removeClass('hide');
      $('.homeCartItemCount').html(list.items().length);
      setTimeout(function(){
        $('.removeTextMsg').removeClass('open');
        $('.addToHomeTryBtnImg').removeClass('disabled');
      },1000);
      $(this).prev('.addToHomeTryBtnImg').show();
      if(list.items().length == 0){
        $('.homeTryImgAddedCart').hide();
        $('.homeTryImgCart').show();
      }
    });
  
  var newCookiesValue = list.items();
  $('.tooltiptext').removeClass('hide');
  
  $.each(newCookiesValue, function(index, value) {
    var handleV = value.split('_variantID_');
    $('#product-loop .product').each(function(){
      var productHandleGet = $(this).find('.addToHomeTryBtn');
      var variantIDCu = $(this).find('.variant-selector').attr('data-value');
      if(handleV[0] == productHandleGet.attr('data-producthandle')){
        $(this).find('.addedHomeTryBtn').show();
        $(this).find('.addToHomeTryBtnImg').hide();
        $(this).find('.tooltiptext').addClass('hide');
        $(this).find('.variant-selector').removeClass('active');
        $(this).find('.variant-selector').each(function(){
          if(handleV[1] == $(this).attr('data-value')){
            $(this).addClass('active');
          }
        })
      }
    });
    if($('.product_form .addToHomeTryBtn').attr('data-producthandle') == handleV[0] && $('.product_form .addToHomeTryBtn').attr('data-varientid')  == handleV[1]){
      $('.productaddedHomeTry').show();
      $('.productaddHomeTry').hide();
    }
    $('.homeTryImgAddedCart').show();
    $('.homeTryImgCart').hide();
  })

  
  $.each(newCookiesValue, function( index, value ) {
    var handleV = value.split('_variantID_');
    $('.countProductAddInCart,.homeCartItemCount').html(list.items().length);
    $.ajax({
      url: 'https://madaboutspecs.co.uk/products/'+handleV[0],
      type: 'GET',
      dataType: 'json',
      success: function (product) {
        
        var productObj = product.product;
        var html = ''; 
        var vender = productObj.vendor;
        var compare = productObj.variants[0].compare_at_price;
        var variant_compare_at_price,variant_price,variant_ID,variant_IMG;
        $(productObj.variants).each(function(){
          if($(this)[0].id == handleV[1]){
          	variant_ID =  $(this)[0].id;
            variant_IMG =  $(this)[0].image_id;
            variant_price =  $(this)[0].price;
            variant_compare_at_price =  $(this)[0].compare_at_price;
          }
        });
        function findObjectByKey(array, key, value) {
          for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
              return array[i];
            }
          }
          return null;
        }

        var obj = findObjectByKey(productObj.images, 'id', variant_IMG);
        
        html += '<tr class="order-item-listing item-listing">';    
        html += '<td>';    
        html += '<div class="cart-item"><div class="cart-image">';    
        html += '<a href="/products/'+productObj.handle+'" title="'+productObj.title+'">';    
        html += '<img src="'+ obj.src +'"  alt="'+productObj.title+'" style="max-width:150px;"/>';    
        html += '</a>';    
        html += '</div>';    
        html += '<div class="cart-title">';    
        if(vender != null){
          html += '<p>'+ productObj.vendor +'</p>';    
        }
        html += '<p>'+productObj.title+'</p>';    
        html += '</div></div>';    
        html += '</div>';    
        html += '</td>';    
        html += '<td>';    
        html += '<p>';    
        html += '<span class="saso-cart-item-price" data-price="'+productObj.variants[0].price+'">'+productObj.variants[0].price+'TL</span>';
        if(compare != null){
          html += '<br /><del>'+variant_compare_at_price+'TL</del>';    
        }
        html += '</p></td>';    
        html += '<td style="text-align: center">';    
        html += '<p>';    
        html += '<a href="javascript:void(0);" class="homr_tryRemove" data-varientid="'+variant_ID+'" data-handleItem="'+productObj.handle+'" rel="'+productObj.id+'">';    
        html += 'Remove Item';    
        html += '</a>';    
        html += '</td>';    
        html += '</tr>';        
        $('#shopping-cart').find('.subtext').hide();
        $('#cartform').show();
        $('#home_tryData').append(html);
        
        
        /* CartDetail Popup */
        var poupHTML = '';
        poupHTML +='<div class="cartInfo"><div class="product__image">';
        poupHTML +='<img src="'+ productObj.image.src +'"  alt="'+productObj.title+'" style="max-height:60px;"/>';
        poupHTML +='</div>';
        poupHTML +='<div class="product__title">';
        poupHTML +='<h4>'+productObj.title+'</h4>';
        /*poupHTML += '<p>'+variant_price+'TL</p>';*/
        poupHTML +='</div></div><div class="clear"></div>';
        $('.orderCartDetail').append(poupHTML);
         
        /* EneddCartDetail Popup */         
          
        var inputHTML = '';
            inputHTML += '<input name="line_items['+index+'][variant_id]" class="product_id" type="hidden"  value="'+variant_ID+'">';
            inputHTML += '<input name="line_items['+index+'][variant_price]" class="product_id" type="hidden"  value="'+variant_price+'">';
         
        $('.inputTypeHidden').append(inputHTML);
        
        var grandTotal = 0;
        $('.order-item-listing').each(function(){
          var price = parseInt($(this).find('.saso-cart-item-price').attr('data-price'));
          grandTotal += price;
        });
        $('.grande__total p,.saso-cart-original-total').html(grandTotal+'TL');
        
        /* Remove Item */
        setTimeout(function(){
          $('body').on('click','.homr_tryRemove',function(){
            var itemHandle = $(this).attr('data-handleitem');
            var itemID = $(this).attr('data-varientid');
            var removeCookVlaue = list.remove(itemHandle+'_variantID_'+itemID); 
            var newCookiesValue = list.items();
            var blkstr = [];
            $.each(newCookiesValue, function(idx2,val2) {                    
              var str = val2;
              blkstr.push(str);
            });
            var NewValueofString = blkstr.join(",");
            $.cookie('home_try_cart', NewValueofString, { expires: 9999999999 , path:'/' });
			window.location.href = 'https://madaboutspecs.co.uk/pages/home-try-cart';
          });
        },500);
        /* Eneded Remove Item */
        
      },
      error: function(textStatus) {
        console.log(textStatus); 
      }
    });
  });
  
  $('body').on('click','.orderSummury__mobile',function(){
    $(this).next('.sidebar__popup').slideToggle();
  });
  
  $('body').on('click','#btn__checkOut',function(){
    $('.start-trial-popup').fadeIn();
    $('body').addClass('body-fixed');
  });

  $('.pop-up-close,.overlay-close').click(function () {
    $(this).parents('.popup').fadeOut();
    $('body').removeClass('body-fixed');
  });    
});


jQuery(document).ready(function() {
  jQuery('body').on('click', '#lens-selection-trigger-clone', function() {
    jQuery('#lens-selection-trigger').click();
    return false;
  });
  jQuery('body').on('click', '#noPrescription-clone', function() {
    jQuery('#noPrescription').click();
    return false;
  });
  setTimeout(function() {
    announcementSize();
  },1000);
  jQuery(window).on('resize', function() {
    announcementSize();
  });
  jQuery(window).on('orientationchange', function() {
    announcementSize();
  });
  jQuery(window).on('scroll', function() {
    filterPosition();
  });
  
  function announcementSize() {
    var height = jQuery('#qab_content').height();
    console.log(height);
    jQuery('#qab_container').css('height', height+'px');
    jQuery('.site-header--fixed, .site-header.site-header--homepage, #mobileNavBar, #StickyBar.sticky--active, .js-sticky-action-bar .action-area, .site-header.page-element:not(.is-moved-by-drawer), .nav-mobile, .ajaxify-drawer, .sticky-navigation-container.sticky.stuck, #MobileNav, .header__close.fixed, .site-header-sticky .site-header--stuck, .nav-container.nav-sticky, #navbarStickyDesktop.nav-sticky, .site-header.has-scrolled, .site-header.headroom, #site-header.site-header, body[class^="trademark--"] .shopify-section__header, [data-header-sidebar="true"] .main-sidebar, .ui.sticky.top, header.hero-active .hero-image-header-wrap, .header.sticky .bar.fixed, body[class^="kagami--"] #shopify-section-header, #page header.util, body:not(.show-mobile-nav) #toolbar.docked, body.show-mobile-nav #mobile-nav .inner, body.sticky-header .header .header-main-content[data-header-content], #nav .wsmenu, .header__mobile-nav, .searching .search-bar-wrapper, #shopify-section-header .coverheader, .header.sticky-header--true, .header.sticky-header--false.is-absolute, #header.mobile-sticky-header--true, #site-control.site-control, .nav-shift #page-banner.banner-under-header, .nav-shift .container #main, #shopify-section-general-header .main-header-wrapper + .header-drawer, .header-section .stuckMenu.isStuck, #shopify-section-mobile-navigation .shifter-navigation, .header-wrapper .sticky-header-wrapper.sticky, #mobile-header #mobile-nav.mobile-nav, header.is-sticky.st-visible, header#top.header, header#velaHeader.velaHeader, body.fixed-header.fixed-header--all > header, #nav + #content_wrapper.mm-page, .main_content_area.content.container, .bodywrap.cf .page-header.cf, .bodywrap.cf .page-header.cf + #navbar.nav-style-out').css("cssText", "top: "+height+"px !important;");
  }
  function filterPosition() {
    var announcementHeight = jQuery('#qab_content').height();
    var headerHeight = jQuery('.coverheader').height();
    if ( jQuery(window).width() < 500 ) {
      headerHeight = jQuery('#mobile-cart').height();
    }
    var height = announcementHeight + headerHeight;
    if (jQuery('.tag-filters').hasClass('sticky-filters') ) {
      jQuery('.tag-filters').css('top', height+'px');
    } else {
      jQuery('.tag-filters').css('top', '');
    }
    
  }
});